(function () {
  'use strict';

  var lastCartTrigger = null;
  var cartTrigger = null;
  var announcementTimer;
  var restoreTimer;
  var uniqueId = 0;
  var strings = {};
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function visible(element) {
    return element && element.isConnected && element.getClientRects().length && !element.closest('[inert], [hidden], [aria-hidden="true"]');
  }

  function clearAnnouncements() {
    clearTimeout(announcementTimer);
    ['fc-cart-status', 'fc-cart-error'].forEach(function (id) {
      var region = document.getElementById(id);
      if (region) region.textContent = '';
    });
  }

  function announce(message, error) {
    var region = document.getElementById(error ? 'fc-cart-error' : 'fc-cart-status');
    if (!region) return;
    clearAnnouncements();
    announcementTimer = setTimeout(function () {
      region.textContent = message || strings.cartError;
    }, 150);
  }

  function openCart(panel, response, form, success, requestedItems) {
    if (!panel || !panel.isConnected) return;
    clearTimeout(restoreTimer);
    clearAnnouncements();
    cartTrigger = form && form.querySelector('[type="submit"]') || lastCartTrigger;
    var items = Array.isArray(response) ? response : response && response.items || (response ? [response] : []);
    var quantity = form && form.querySelector('[name="quantity"]');
    var messages = items.map(function (item) {
      var requested = requestedItems && requestedItems.find(function (entry) { return String(entry.id) === String(item.variant_id || item.id); });
      var count = requested ? requested.quantity : quantity ? quantity.value : item.quantity;
      var title = item.product_title || item.title;
      if (!title) return '';
      return strings.cartAdded.replace('[quantity]', String(count || 1)).replace('[product]', title);
    }).filter(Boolean);
    var message = messages.join('. ') || panel.textContent.trim();

    // Give focus one complete success message instead of racing a live-region update.
    if (document.activeElement === panel) panel.blur();
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', success ? message : strings.cartDialog);
    panel.setAttribute('tabindex', '-1');
    panel.removeAttribute('aria-hidden');
    panel.removeAttribute('inert');
    panel.querySelectorAll('svg').forEach(function (svg) { svg.setAttribute('aria-hidden', 'true'); });
    panel.focus({ preventScroll: true });

    if (!success) {
      announce(panel.querySelector('.ajax-content') ? panel.querySelector('.ajax-content').textContent.trim() : panel.textContent.trim(), true);
    } else if (document.activeElement !== panel) {
      announce(message);
    }
  }

  function closeCart() {
    clearAnnouncements();
    var panels = document.querySelectorAll('.ajaxified-cart-feedback');
    panels.forEach(function (panel) {
      panel.setAttribute('aria-hidden', 'true');
      panel.setAttribute('inert', '');
    });
    if (window.jQuery) window.jQuery(panels).stop(true, true).slideUp();
    else panels.forEach(function (panel) { panel.style.display = 'none'; });
    var trigger = cartTrigger;
    var attempts = 0;
    function restore() {
      if (visible(trigger) && !trigger.disabled) {
        trigger.focus({ preventScroll: true });
      } else if (trigger && trigger.isConnected && trigger.disabled && attempts++ < 15) {
        restoreTimer = setTimeout(restore, 100);
      } else {
        var cartLink = document.querySelector('.site-header__cart');
        if (visible(cartLink)) cartLink.focus({ preventScroll: true });
      }
    }
    restore();
  }

  window.FieldAccessibility = { openCart: openCart, closeCart: closeCart, announce: announce };

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.product-form__cart-submit, form[action="/cart/add"] [type="submit"]');
    if (button) lastCartTrigger = button;
    var videoControl = event.target.closest('button[aria-controls]');
    if (videoControl) (videoControl.getAttribute('aria-controls') || '').split(' ').forEach(function (id) {
      var video = document.getElementById(id);
      if (video && video.tagName === 'VIDEO') video.dataset.fcUserStarted = 'true';
    });
  }, true);
  document.addEventListener('submit', function (event) {
    if (event.target.matches('form[action="/cart/add"]')) lastCartTrigger = event.submitter || event.target.querySelector('[type="submit"]');
  }, true);
  document.addEventListener('keydown', function (event) {
    var panel = event.target.closest('.ajaxified-cart-feedback');
    if (!panel || panel.hasAttribute('inert')) return;
    if (event.key === 'Escape') { event.preventDefault(); closeCart(); }
    var control = event.target.closest('[role="button"]');
    if (control && (event.key === ' ' || event.key === 'Enter' && control.tagName !== 'A')) {
      event.preventDefault();
      control.click();
    }
  });

  function enhanceOptions(root) {
    root.querySelectorAll('select[data-product-option-navigation]').forEach(function (select) {
      if (select.dataset.fcOptionReady) return;
      select.dataset.fcOptionReady = 'true';
      var go = document.createElement('a');
      go.className = 'visually-hidden fc-option-go';
      go.textContent = strings.viewSelectedOption;
      go.hidden = true;
      select.insertAdjacentElement('afterend', go);
      var instructions = document.createElement('span');
      instructions.id = 'fc-option-instructions-' + ++uniqueId;
      instructions.className = 'visually-hidden';
      instructions.textContent = strings.optionInstructions;
      select.insertAdjacentElement('afterend', instructions);
      select.setAttribute('aria-describedby', [select.getAttribute('aria-describedby'), instructions.id].filter(Boolean).join(' '));
      function update() {
        var value = select.value;
        var isProduct = /^\/products\/[^\s]+$/.test(value);
        go.hidden = !isProduct;
        if (isProduct) {
          go.href = value;
          go.setAttribute('aria-label', strings.viewSelectedOption + ': ' + select.selectedOptions[0].textContent.trim());
        } else go.removeAttribute('href');
      }
      select.addEventListener('change', update);
      select.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' && /^\/products\//.test(select.value)) {
          event.preventDefault();
          window.location.assign(select.value);
        }
      });
      update();
    });
  }

  function enhanceContent(root) {
    root.querySelectorAll('[class*="fc-slider__stars-"][aria-label]').forEach(function (stars) { stars.setAttribute('role', 'img'); });
    root.querySelectorAll('img.topic-image:not([alt])').forEach(function (image) { image.alt = ''; });
    root.querySelectorAll('img[alt=""]').forEach(function (image) {
      if (image.src.indexOf('/Carekit.png') !== -1 && image.closest('a[href*="/products/cast-iron-care-kit"]')) image.alt = strings.careKit;
    });
    root.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(function (heading) {
      if (!heading.textContent.trim() && !heading.querySelector('img[alt]:not([alt=""]), svg, video') && !heading.getAttribute('aria-label') && !heading.getAttribute('aria-labelledby')) heading.setAttribute('role', 'presentation');
    });
    root.querySelectorAll('iframe:not([title]):not([aria-label])').forEach(function (frame) {
      if (/youtube\.com\/embed\/1BvkVzGpW6E/.test(frame.src)) frame.title = strings.careVideo;
    });
    var destinations = {
      '/pages/about': strings.about,
      '/pages/five-field-skillet-design-details': strings.skilletDetails,
      '/pages/does-cast-iron-work-on-induction-cooktops': strings.induction,
      '/blogs/journal/introducing-no5-chef-skillet': strings.chefSkillet,
      '/pages/the-best-oils-for-seasoning-cast-iron': strings.seasoningOil,
      '/pages/cast-iron-cleaning-care-field-method': strings.cleaning,
      '/blogs/journal/cast-iron-seared-scallops-with-grilled-creamed-corn': strings.scallops,
      '/blogs/journal': strings.journal
    };
    root.querySelectorAll('a[href]').forEach(function (link) {
      if (/^https?:$/.test(link.protocol) && link.hostname === window.location.hostname || link.getAttribute('href').charAt(0) === '#') {
        var descriptions = (link.getAttribute('aria-describedby') || '').split(' ').filter(function (id) { return id !== 'a11y-external-message' && id !== 'a11y-new-window-external-message'; });
        if (descriptions.filter(Boolean).length) link.setAttribute('aria-describedby', descriptions.filter(Boolean).join(' '));
        else link.removeAttribute('aria-describedby');
      }
      var text = link.textContent.trim();
      var destination = destinations[link.pathname.replace(/\/$/, '')];
      if (destination && /^read\s+more(?:\s*[→>])?$/i.test(text)) link.setAttribute('aria-label', strings.readMore.replace('[label]', text).replace('[title]', destination));
      if (destination && !text && !link.querySelector('img[alt]:not([alt=""]), svg[aria-label]')) link.setAttribute('aria-label', destination);
      if (text === 'Cast Iron Griddles') {
        if (link.pathname === '/collections/field-griddles') link.setAttribute('aria-label', strings.griddlesField);
        else if (link.pathname === '/collections/cast-iron-griddles') link.setAttribute('aria-label', strings.griddlesShop);
      }
    });
  }

  function enhanceVideos(root) {
    root.querySelectorAll('video').forEach(function (video) {
      if (video.dataset.fcA11yReady || !video.matches('[autoplay], [loop], [aria-label]')) return;
      video.dataset.fcA11yReady = 'true';
      if (!video.id) video.id = 'fc-background-video-' + ++uniqueId;
      video.addEventListener('play', function () {
        if (motion.matches && video.dataset.fcUserStarted !== 'true') video.pause();
      });
      var label = video.getAttribute('aria-label');
      if (label) {
        video.removeAttribute('aria-label');
        var wrapper = video.parentElement;
        if (wrapper.tagName !== 'A' && !wrapper.hasAttribute('role')) wrapper.setAttribute('role', 'group');
        if (!wrapper.hasAttribute('aria-label')) wrapper.setAttribute('aria-label', label);
      }
      var controlled = Array.from(root.querySelectorAll('button[aria-controls]')).some(function (button) { return button.getAttribute('aria-controls').split(' ').indexOf(video.id) !== -1; });
      if (!controlled && !video.controls) {
        var stopTimer;
        var userStarted = false;
        video.addEventListener('play', function () {
          if (motion.matches && !userStarted) { video.pause(); return; }
          if (!userStarted) {
            clearTimeout(stopTimer);
            stopTimer = setTimeout(function () { video.pause(); video.removeAttribute('autoplay'); }, 4800);
          }
        });
        if (!video.paused) stopTimer = setTimeout(function () { video.pause(); video.removeAttribute('autoplay'); }, 4800);
        var media = video.parentElement;
        if (media.tagName !== 'A' && !media.querySelector('button')) {
          media.setAttribute('role', 'group');
          media.setAttribute('tabindex', '0');
          if (!media.hasAttribute('aria-label')) media.setAttribute('aria-label', strings.videoTitle);
          var hint = document.createElement('span');
          hint.className = 'visually-hidden';
          hint.id = 'fc-video-hint-' + ++uniqueId;
          hint.textContent = strings.videoInstructions;
          media.appendChild(hint);
          media.setAttribute('aria-describedby', hint.id);
          media.addEventListener('keydown', function (event) {
            if (event.target !== media || event.key !== ' ') return;
            event.preventDefault();
            userStarted = true;
            video.dataset.fcUserStarted = 'true';
            clearTimeout(stopTimer);
            if (video.paused) video.play().catch(function () {});
            else video.pause();
          });
        }
      }
      if (motion.matches) video.pause();
    });
  }

  function init(root) {
    enhanceOptions(root);
    enhanceContent(root);
    enhanceVideos(root);
  }

  function ready() {
    var data = document.getElementById('fc-accessibility-strings');
    if (data) strings = JSON.parse(data.textContent);
    init(document);
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
    motion.addEventListener('change', function () {
      if (motion.matches) document.querySelectorAll('video[autoplay], video[loop]').forEach(function (video) { video.pause(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
